/** Ключ файла в порции загрузки: тот же файл, выбранный повторно, второй раз в порцию не попадает */
export const getRecordFileKey = (file: File): string => `${file.name}|${file.size}|${file.lastModified}`;
